// External globals
import { App } from '@/services/app-compat';
import { api } from '@/services/api-class';
import { hasValue } from '@/utils/legacy-utils';

export function ADMIN_Home() {
    (window as any).initHomeScreen('Administration Module', 'Admin', HelpDeskType.AdminGettingStarted);
}

export function ADMIN_Selected() {
    ADMIN_Home();
}

// Window registrations
(window as any).ADMIN_Home = ADMIN_Home;
(window as any).ADMIN_Selected = ADMIN_Selected;
